import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../App.css";
import { FaGithub } from "react-icons/fa";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [tokensOpen, setTokensOpen] = useState(false);
  const [activeButton, setActiveButton] = useState("");

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const openWhitepaper = () => {
    window.open("/Garetto_Whitepaper.pdf", "_blank");
    setMenuOpen(false);
  };

  // const openSurvey = () => {
  //   window.open(
  //     "https://docs.google.com/forms/d/e/1FAIpQLSfk4YxCt23TPqpU4Go0ERzTNSvoxR3tJ_lISQpU6GIO_cO8EA/viewform?usp=sharing&ouid=115956422643742222681",
  //     "_blank",
  //   );
  // };

  return (
    <header className="header">
      {/* LEFT */}
      <div className="headerSides desktop">
        <a
          href="https://github.com/lernoh2/RETO/tree/Garetto"
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub className="socialIcons" />
        </a>
      </div>

      {/* DESKTOP MENU */}
      <div className="header-buttons desktop">
        <Link to="/" className="link">
          <div
            className={`headerItem ${activeButton === "homepage" ? "active" : ""}`}
            onClick={() => handleButtonClick("homepage")}
          >
            HOME
          </div>
        </Link>
        <Link to="/about" className="link">
          <div
            className={`headerItem ${activeButton === "about" ? "active" : ""}`}
            onClick={() => handleButtonClick("about")}
          >
            ABOUT
          </div>
        </Link>
        <Link to="/contact" className="link">
          <div
            className={`headerItem ${activeButton === "contact" ? "active" : ""}`}
            onClick={() => handleButtonClick("contact")}
          >
            CONTACT
          </div>
        </Link>
        <Link to="/roadmap" className="link">
          <div
            className={`headerItem ${activeButton === "roadmap" ? "active" : ""}`}
            onClick={() => handleButtonClick("roadmap")}
          >
            ROADMAP
          </div>
        </Link>
        {/* 🔥 TOKENS DROPDOWN */}
        <div className="tokens-dropdown">
          <button
            className={`headerItem ${activeButton === "tokens" ? "active" : ""}`}
            onClick={() => setTokensOpen(!tokensOpen)}
          >
            <h3 style={{ fontSize: "18px" }}>TOKENS</h3>
          </button>

          {tokensOpen && (
            <div className="tokens-menu">
              <Link to="/gettoavax" className="link">
                <div
                  className={`headerItemDrop ${activeButton === "gettoavax" ? "active" : ""}`}
                  onClick={() => handleButtonClick("gettoavax")}
                >
                  <h6>G-ETTO on Avalanche</h6>
                </div>
              </Link>
              <Link to="/gettobase" className="link">
                <div
                  className={`headerItemDrop ${activeButton === "gettobase" ? "active" : ""}`}
                  onClick={() => handleButtonClick("gettobase")}
                >
                  <h6>G-ETTO on Base</h6>
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* RIGHT (desktop) */}

      <div className="headerSides">
        <button onClick={openWhitepaper} className="whiteButton">
          WHITEPAPER
        </button>
      </div>

      {/* MOBILE LEFT LOGO */}

      <div className="mobile-logo">
        <img src="/logo.svg" alt="token logo" className="mobile-logo-img" />
      </div>

      {/* HAMBURGER */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <div className="mobile-links">
            <Link to="/" className="link">
              <div
                className={`headerItem ${activeButton === "homepage" ? "active" : ""}`}
                onClick={() => handleButtonClick("homepage")}
              >
                HOME
              </div>
            </Link>
            <Link to="/about" className="link">
              <div
                className={`headerItem ${activeButton === "about" ? "active" : ""}`}
                onClick={() => handleButtonClick("about")}
              >
                ABOUT
              </div>
            </Link>
            <Link to="/contact" className="link">
              <div
                className={`headerItem ${activeButton === "contact" ? "active" : ""}`}
                onClick={() => handleButtonClick("contact")}
              >
                CONTACT
              </div>
            </Link>
          </div>
          {/* MOBILE TOKENS */}
          <div className="mobileTokens">
            <button onClick={() => setTokensOpen(!tokensOpen)}>TOKENS</button>

            {tokensOpen && (
              <div className="mobileTokensMenu">
                <Link to="/gettoavax" className="link">
                  <div
                    className={`headerItem ${activeButton === "gettoavax" ? "active" : ""}`}
                    onClick={() => handleButtonClick("gettoavax")}
                  >
                    G-ETTO - AVAX
                  </div>
                </Link>
                <Link to="/gettobase" className="link">
                  <div
                    className={`headerItem ${activeButton === "gettobase" ? "active" : ""}`}
                    onClick={() => handleButtonClick("gettobase")}
                  >
                    G-ETTO - BASE
                  </div>
                </Link>
              </div>
            )}

            <button className="headerItem" onClick={openWhitepaper}>
              WHITEPAPER
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
